import { DomainUpsertLoadingList } from "@/components/domain";
import { useSyncLoading } from "@/context/sheet";
import { useGetRegion, useUpdateRegion } from "@/hooks/regions";
import { CreateRegion, Region } from "@/models";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { Form } from "./-form";

export const Route = createFileRoute("/(regions)/regions/_sheet/$id/edit")({
  component: RouteComponent,
});

function RouteComponent() {
  const { id } = Route.useParams();

  const { isLoading, data: model } = useGetRegion(id);
  useSyncLoading(isLoading);

  if (isLoading || !model) return <DomainUpsertLoadingList />;
  return <Edit model={model} />;
}

function Edit({ model }: { model: Region }) {
  const navigate = useNavigate();
  const { mutateAsync } = useUpdateRegion({
    onSuccess: (region) => {
      navigate({
        to: "/regions",
        params: { id: region.id.toString() },
      });
    },
  });

  const update = async (region: CreateRegion) => {
    await mutateAsync({ id: model.id, ...region });
  };
  return <Form model={model} onUpsert={update} />;
}
